module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Domain Name",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDomain)); }],
      "required": ""
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.types,
      "label": _vm.$lang.labels.domainType,
      "loading": _vm.domainLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDomainType)); }],
      "required": ""
    },
    model: {
      value: (_vm.domainType),
      callback: function($$v) {
        _vm.domainType = $$v
      },
      expression: "domainType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.registeredOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.registeredOn = $event
      },
      "update:return-value": function($event) {
        _vm.registeredOn = $event
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingRegisteredOn)); }],
      "label": "Registration Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.formattedRegisteredOn),
      callback: function($$v) {
        _vm.formattedRegisteredOn = $$v
      },
      expression: "formattedRegisteredOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.registeredOn)
      }
    },
    model: {
      value: (_vm.registeredOn),
      callback: function($$v) {
        _vm.registeredOn = $$v
      },
      expression: "registeredOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.deregisteredOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.deregisteredOn = $event
      },
      "update:return-value": function($event) {
        _vm.deregisteredOn = $event
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Deregistration Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.formattedDeregisteredOn),
      callback: function($$v) {
        _vm.formattedDeregisteredOn = $$v
      },
      expression: "formattedDeregisteredOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.deregisteredOn)
      }
    },
    model: {
      value: (_vm.deregisteredOn),
      callback: function($$v) {
        _vm.deregisteredOn = $$v
      },
      expression: "deregisteredOn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'domains'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e1d5b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/domains/NewDomain.vue
// module id = 403
// module chunks = 35